import { Api as MicromagApi } from '@micromag/data';

import AnalyticsApi from './Analytics';
import AuthApi from './Auth';
import AccountApi from './Account';
import MediasApi from './Medias';
import OrganisationsApi from './Organisations';
import StoriesApi from './Stories';
import ThemesApi from './Themes';
import QuizApi from './Quiz';
import ContributionsApi from './Contributions';
import ContactApi from './Contact';

class Api extends MicromagApi {
    constructor(opts = {}) {
        const options = {
            baseUrl: '/',
            ...opts,
        };
        super(options);

        this.auth = new AuthApi(options);
        this.account = new AccountApi(options);
        this.medias = new MediasApi(options);
        this.organisations = new OrganisationsApi(options);
        this.stories = new StoriesApi(options);
        this.themes = new ThemesApi(options);
        this.analytics = new AnalyticsApi(options);
        this.quiz = new QuizApi(options);
        this.contributions = new ContributionsApi(options);
        this.contact = new ContactApi(options);
    }
}

export default Api;
